import { useCallback, useMemo } from 'react'

import { useNavigationContext } from './useNavigationContext'

export function useMainNavigationState() {
    const {
        workspaceNavState,
        mainNavState,
        selectedApp,
        isPortal,
        showTrialBanner,
        isMobileDevice,
        showNavigationStateControl,
    } = useNavigationContext()

    const isNavHidden =
        mainNavState === 'collapsed' ||
        mainNavState === 'touch-collapsed' ||
        (!selectedApp && !isPortal)

    const isWorkspaceNavHidden = workspaceNavState === 'hidden'

    const onNavigationWrapperClick = useCallback((e: React.MouseEvent<HTMLDivElement>) => {
        e.stopPropagation()
    }, [])

    return useMemo(
        () => ({
            isNavHidden,
            isPortal,
            showTrialBanner,
            isWorkspaceNavHidden,
            isMobileDevice,
            showNavigationStateControl,
            onNavigationWrapperClick,
        }),
        [
            isNavHidden,
            isPortal,
            showTrialBanner,
            isWorkspaceNavHidden,
            isMobileDevice,
            showNavigationStateControl,
            onNavigationWrapperClick,
        ]
    )
}
